// Busca e seleção de produtos e páginas
(function () {
  'use strict';

  // Variáveis globais
  const $modal = $('#select-prods-modal');
  const $formSearch = $('#form-select-produtos');
  const $searchInput = $('#campo-busca-produtos');
  const $selectList = $('#select-produtos-list');
  const $curSelecteds = $('#current-selecteds');
  const $btnAddSelecteds = $('#select-produtos-btn-add');
  const $selectAllWrp = $('.select-produtos-select-all-wrp');
  const $selectAll = $('#select-produtos-select-all');
  let spLoading = false;

  // Textos de acordo com o tipo de conteúdo
  const spTxt = {
    products: {
      'apply-all': 'Aplicar para todos produtos',
      'btn-add': '+ Selecionar produtos',
      'modal-tit': 'Selecionar Produtos',
      'table-tit': 'Produtos selecionados',
      'table-empty': 'Nenhum produto selecionado.',
      'list-empty': 'Nenhum produto adicionado.',
      'busca-lbl': 'Busque e selecione os produtos desejados',
      'busca-ph': 'Buscar produtos...',
      'select-alert': 'Selecione pelo menos um produto para adicionar.',
      'load-erro': 'Não foi possível carregar os produtos',
      'not-found': 'O produto buscado não foi encontrado ou já foi adicionado na lista.',
    },
  };

  $('.select-prods-wrp').each(function () {
    // Variáveis
    const $selectWrp = $(this);
    const $applyAll = $selectWrp.find('.select-prods-apply-all');
    const $selectIn = $selectWrp.find('.select-prods-in');
    const $btnAdd = $selectWrp.find('.select-prods-add');
    const $table = $selectWrp.find('.table');
    const $tableList = $table.find('tbody');
    const $productsIds = $selectWrp.find('.select-prods-ids');
    let addId = $productsIds.data('add-id') || false;
    const contentType = $selectWrp.data('type') || 'products';
    const apiUrl = $selectWrp.data('url');
    let reqAjax = null;
    let reqAjaxList = null;
    let listEnd = false;
    let curPage = 1;

    // Inicialização
    handleTexts();
    $formSearch.find('input[name="type"]').val(contentType);

    // Aplica os textos de acordo com o tipo de contéudo
    function handleTexts() {
      $btnAdd.html(spTxt[contentType]['btn-add']);
      $selectIn.find('.card-title').html(spTxt[contentType]['table-tit']);
      $modal.find('.modal-title').html(spTxt[contentType]['modal-tit']);
      $modal.find('label[for="campo-select-produtos"]').html(spTxt[contentType]['busca-lbl']);
      $searchInput.attr('placeholder', spTxt[contentType]['busca-ph']);
    }

    // Ao alterar a opção de aplicar para todos os produtos
    if ($applyAll.length) {
      $selectIn.addClass('mt-3');
      handleApplyAll();
      function handleApplyAll() {
        if ($applyAll.is(':checked')) {
          $selectIn.hide();
        } else {
          $selectIn.show();
          loadAddItens();
        }
      }
      $applyAll.on('change', handleApplyAll);
    } else {
      $selectIn.show();
      loadAddItens();
    }

    // Exibe o modal para seleção
    $btnAdd.on('click', function (ev) {
      ev.preventDefault();
      showModalAdd();
    });
    function showModalAdd() {
      $modal.modal('show');
    }

    // Ao abrir o modal de seleção
    $modal.on('show.bs.modal', function (ev) {
      if (curPage === 1) {
        searchProds();
      }
    });

    // Ao fechar o modal de seleção
    $modal.on('hidden.bs.modal', function (ev) {
      if (reqAjax != null) {
        reqAjax.abort();
      }
      //resetSearchList();
    });

    // Realiza a busca ao digitar do campo de busca
    $searchInput.on('input', function () {
      let search = $searchInput.val().trim() || '';
      if (reqAjax != null) {
        reqAjax.abort();
      }
      listEnd = false;
      curPage = 1;
      searchProds();
    });

    // Ao selecionar um item da lista
    $selectList.on('change', 'input[type="checkbox"]', function () {
      const itemId = $(this).val();
      if (!itemId) {
        return false;
      }
      if ($(this).is(':checked')) {
        updateSelected('add', itemId);
      } else {
        updateSelected('del', itemId);
      }
    });

    // Ao clicar para adicionar os itens
    $btnAddSelecteds.on('click', function (ev) {
      ev.preventDefault();
      const total = getSelectedItens().length;
      if (total > 0) {
        addSelectedItens();
        $modal.modal('hide');
      } else {
        Toast.fire({
          type: 'warning',
          title: spTxt[contentType]['select-alert'],
        });
      }
    });

    // Ao clicar para selecionar todos resultados da lista
    $selectAll.on('change', function (ev) {
      if ($selectAll.is(':checked')) {
        $selectList.find('input[type="checkbox"]').prop('checked', true).trigger('change');
      } else {
        $selectList.find('input[type="checkbox"]').prop('checked', false).trigger('change');
      }
    });

    // Remover um item adicionado
    $tableList.on('click', '.btn-rem', function (ev) {
      ev.preventDefault();
      const $btn = $(this);
      const idRemove = $btn.data('value');
      const $linhaTabela = $tableList.find('tr[data-row="' + idRemove + '"]');
      let itensIds = $productsIds.val().split(',');
      const idRemoveIndex = itensIds.indexOf('' + idRemove);
      if (idRemoveIndex !== -1) {
        updateSelected('del', idRemove);
        itensIds.splice(idRemoveIndex, 1);
        itensIds = itensIds.join(',');
        $productsIds.val(itensIds);
        //$linhaTabela.find('[data-toggle="tooltip"]').tooltip('hide');
        $linhaTabela.remove();
        if ($tableList.find('tr[data-row]').length === 0) {
          $tableList.append('<td colspan="2" class="text-left">' + spTxt[contentType]['list-empty'] + '</td>');
        }
      }
    });

    // Detecta quando o scroll chega ao final da lista
    $selectList.on(
      'scroll',
      debounce(function () {
        if ($selectList.scrollTop() + $selectList.innerHeight() >= $selectList[0].scrollHeight) {
          if (!spLoading && !listEnd) {
            curPage++;
            searchProds();
          }
        }
      }, 50),
    );

    // Adiciona os itens selecionados para a lista principal do formulário
    function addSelectedItens() {
      let itens = getSelectedItens();
      itens.join(',');
      if ($productsIds.val() == '') {
        $productsIds.val(itens);
      } else {
        let newList = $productsIds.val() + ',' + itens;
        newList = newList.split(',');
        const newListClear = newList.filter((item, index) => newList.indexOf(item) === index);
        const newListStr = newListClear.join(',');
        $productsIds.val(newListStr);
      }
      console.log($productsIds.val());
      $productsIds.trigger('change-add');
      loadAddItens();
    }

    // Atualiza a lista de itens selecionados
    function updateSelected(action, itemId) {
      if (!itemId) {
        return false;
      }
      if (typeof itemId === 'number') {
        itemId = itemId.toString();
      }
      let curIds = getSelectedItens();
      if (action === 'add' && curIds.indexOf(itemId) === -1) {
        curIds.push(itemId);
      }
      if (action === 'del' && curIds.indexOf(itemId) !== -1) {
        const itemIx = curIds.indexOf(itemId);
        curIds.splice(itemIx, 1);
      }
      $curSelecteds.val(curIds.join(','));
    }

    // Obtém a lista de itens selecionados
    function getSelectedItens() {
      let curIds = $curSelecteds.val();
      curIds = curIds ? curIds.split(',') : [];
      return curIds;
    }

    // Reseta a lista de busca
    function resetSearchList() {
      listEnd = false;
      curPage = 1;
      $selectList.html('');
      $selectAll.prop('checked', false);
      $selectAllWrp.hide();
    }

    // Busca os produtos
    function searchProds() {
      if (reqAjax != null) {
        reqAjax.abort();
      }
      if (curPage === 1) {
        $selectList.html(`
        <li class="loading">
          <div class="loader-el-wrp active">
            <div class="loader-container">
              <div class="loader-wrapper">
                <div class="loader"></div>
              </div>
            </div>
          </div>
        </li>`);
      } else {
        spLoading = true;
        $selectList.append(`
        <li class="loading loading-more">
          <div class="loader-el-wrp active">
            <div class="loader-container">
              <div class="loader-wrapper">
                <div class="loader"></div>
              </div>
            </div>
          </div>
        </li>`);
      }
      let dataForm = $formSearch.serialize();
      dataForm += '&p=' + curPage;
      if ($productsIds.val() != '') {
        dataForm += '&exclude_ids=' + $productsIds.val();
      }
      if (addId) {
        dataForm += '&edit_id=' + addId;
      }
      reqAjax = $.getJSON(`${apiUrl}?${dataForm}`, function (result) {
        $selectList.find('.loading-more').remove();
        spLoading = false;
        // Sucesso
        if (result.status == 'success') {
          populateSearch(result);
        }
        // Erro
        else {
          console.log(result);
          resetSearchList();
          Toast.fire({
            type: 'error',
            title: spTxt[contentType]['load-erro'],
          });
        }
      });
    }

    // Popula os produtos da busca
    function populateSearch(result) {
      $selectAll.prop('checked', false);
      // Final dos resultados
      if (curPage >= result.total_pages) {
        listEnd = true;
      }
      // Nenhum resultado encontrado
      if (curPage === 1 && result.total_count === 0) {
        $selectList.html('');
        $selectList.append(
          '<li><div class="font-sm text-center p-3">' + spTxt[contentType]['not-found'] + '</div></li>',
        );
        $selectAllWrp.hide();
        return false;
      }
      // Popula a lista
      else if (result.total_count > 0) {
        if (curPage === 1) {
          $selectList.html('');
        }
        const curIds = getSelectedItens();
        result.results.forEach((item) => {
          const checked = curIds.indexOf(item.id) !== -1 ? 'checked' : '';
          $selectList.append(`
          <li>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="select-prod-${item.id}" value="${item.id}" ${checked}>
              <label class="form-check-label" for="select-prod-${item.id}"></label>
            </div>
            <label for="select-prod-${item.id}">
              <img src="${item.image}" class="img-fluid rounded border" width="35px" height="35px">
              <span>${item.text}</span>
            </label>
          </li>`);
        });
        //initTooltips();
        $selectAllWrp.show();
      }
    }

    // Carrega os itens adicionados
    function loadAddItens() {
      $tableList.html(`
      <tr>
        <td colspan="2" class="p-0">
          <div class="loader-el-wrp active">
            <div class="loader-container">
              <div class="loader-wrapper">
                <div class="loader"></div>
              </div>
            </div>
          </div>
        </td>
      </tr>`);
      const itensId = $productsIds.val();
      if (!itensId) {
        populateSelectedItens({
          total_count: 0,
          results: [],
        });
        return false;
      }
      if (reqAjaxList != null) {
        reqAjaxList.abort();
      }
      reqAjaxList = $.getJSON(`${apiUrl}?type=${contentType}&ids=${itensId}`, function (result) {
        // Sucesso
        if (result.status == 'success') {
          populateSelectedItens(result);
        }
        // Erro
        else {
          console.log(result);
          $tableList.html('');
          Toast.fire({
            type: 'error',
            title: spTxt[contentType]['load-erro'],
          });
        }
      });
    }

    // Popula os produtos adicionados
    function populateSelectedItens(result) {
      $tableList.html('');
      if (result.total_count > 0) {
        result.results.forEach((item) => {
          $tableList.append(`
          <tr data-row="${item.id}">
            <td>
              <div class="prod-table-infos">
                <img src="${item.image}" class="img-fluid rounded border mr-3" width="40px" height="40px">
                <span>${item.text}</span>
              </div>
            </td>
            <td width="60px">
              <div class="table-options no-hover">
                <a href="#" class="btn btn-danger btn-rem btn-rem-sm" data-toggle="tooltip" data-placement="bottom" title="Remover" data-value="${item.id}"><i class="las la-trash"></i></a>
              </div>
            </td>
          </tr>`);
        });
      } else {
        $tableList.append('<td colspan="2" class="text-left">' + spTxt[contentType]['list-empty'] + '</td>');
      }
      //initTooltips();
    }
  });
})();
